import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _ActualValue, _FactoryByyear } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../theme/Component/BasicButton";



export const DocumentFactoryByyear = () => {

    const FactoryByyear = useDataBean(_FactoryByyear);
    const ActualValue = useDataBean(_ActualValue)
    const single = Singleton.getInstance();
    const [year, setyear] = useState<any>(_single.getCurrenYear())
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        FactoryByyear.instance.getDocumentFactoryByYear(year).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }
    const setActualValueForCodeFactory = () => {

        ActualValue.instance.setActualValueForCodeFactory(ActualValue.bean.Year, FactoryByyear.bean.DocumentFactory, ActualValue.bean.ActualConsecutive, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Cambio Exitoso')
                    ActualValue.setBean({});
                    setModal({ ...modal, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const create = () => {
        FactoryByyear.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        FactoryByyear.deleteItemVoid(FactoryByyear.bean.IDEntailment).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Agregar Nivel Jerárquico de Empleo`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        FactoryByyear.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDDocumentFactory', visible: true },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Clase Fábrica', property: 'DocumentFactory', visible: true },
        { title: 'Secuencia', property: 'SecuenceName', visible: true },
        { title: 'Min Valor', property: 'MinValue', visible: true },
        { title: 'Valor Actual', property: 'ActualValue', visible: true },
        { title: 'Desde', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Cambiar Numeración', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true, name: "Cambiar Numeración" }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Consecutivos de Fábricas de Documentos">
            <div className="row">
                <div className="col-md-4">
                    <YearSelector value={year} onChange={(e) => { setyear(e) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>Buscar</BasicButton>
                </div>

                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={FactoryByyear.setBean} listButtons={listaBotones()} ></BasicTable>

                    <Modal modal={modal} updateModal={setModal} eventModal={setActualValueForCodeFactory}>
                        <div className="row">
                            <div className="col-md-12">
                                <YearSelector value={ActualValue.bean.Year} onChange={(e) => { ActualValue.setBean({ ...ActualValue.bean, "Year": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Consecutivo Actual</label>
                                <input type='text' name="ActualConsecutive" className="form-control" value={ActualValue.bean.ActualConsecutive} onChange={ActualValue.handleChange} />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {FactoryByyear.bean.Name}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}